import { render, staticRenderFns } from "./add_categories_marketplace_page.vue?vue&type=template&id=c5a69b84"
import script from "./add_categories_marketplace_page.vue?vue&type=script&lang=js"
export * from "./add_categories_marketplace_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports